import React from "react"
import { ShipDeckPlanSlide, ShipDeckPlansSlider } from "@silversea-ssc/ui-components-react"
import clsx from "clsx"
import { match } from "ts-pattern"
import LocalizedShipDeckPlan from "./LocalizedShipDeckPlan"
import styles from "./LocalizedShipDeckPlansSlider.module.scss"
import { labelDeckOfTotal } from "./labels"

export type CompletedShipDeckPlanSlideProps = {
    svgURL: string
    color?: string
    title: string
    deckNumber: number
}

export type MinimalShipDeckPlanSlideProps = {
    svgURL: string
    deckNumber: number
}

type Props =
    | {
          variant: "complete"
          deckPlans: readonly CompletedShipDeckPlanSlideProps[]
          totalDecksNumber: number
      }
    | {
          variant: "minimal"
          deckPlans: readonly MinimalShipDeckPlanSlideProps[]
          totalDecksNumber: number
      }

const LocalizedShipDeckPlansSlider: React.FC<React.PropsWithChildren<Props>> = (props) => {
    const { totalDecksNumber, variant } = props
    const isMinimal = variant === "minimal"

    return (
        <ShipDeckPlansSlider>
            {deckPlansFromProps(props).map(({ deckNumber, svgURL, color, title, ...deck }) => (
                <ShipDeckPlanSlide
                    key={deckNumber}
                    title={title}
                    caption={labelDeckOfTotal(deckNumber, totalDecksNumber)}
                    color={color}
                    className={clsx({ [styles.deckLegend]: isMinimal })}
                >
                    <LocalizedShipDeckPlan {...deck} deckPlanSVGUrl={svgURL} showFeatures={!isMinimal} />
                </ShipDeckPlanSlide>
            ))}
        </ShipDeckPlansSlider>
    )
}

export default LocalizedShipDeckPlansSlider

const deckPlansFromProps = (props: Props) =>
    match(props)
        .with({ variant: "complete" }, ({ deckPlans }) => deckPlans)
        .with({ variant: "minimal" }, ({ deckPlans }) =>
            deckPlans.map((x) => ({
                color: undefined,
                title: undefined,
                ...x,
            })),
        )
        .exhaustive()
